<template>
  <div>
    <small>Cluster date</small>
    <FilterTypeDate fromType="clusterDateFrom" toType="clusterDateTo" />
    <small>Cluster end date</small>
    <FilterTypeDate
      fromType="clusterEndDateFrom"
      toType="clusterEndDateTo"
    />
  </div>
</template>

<script>
import FilterTypeDate from "./FilterTypeDate.vue";

export default {
  name: "ClusterDatesFilter",
  components: { FilterTypeDate },
};
</script>

<style>
</style>
